module.exports = __webpack_public_path__ + "img/luxembourg.09ee6040.svg";